"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marketActivityApplyAudit = marketActivityApplyAudit;
exports.marketActivityApplyDelete = marketActivityApplyDelete;
exports.marketActivityApplyInfo = marketActivityApplyInfo;
exports.marketActivityApplyList = marketActivityApplyList;
exports.marketActivityApplyRefund = marketActivityApplyRefund;
exports.marketActivityApplySave = marketActivityApplySave;
exports.marketActivityApplySpreadAudit = marketActivityApplySpreadAudit;
exports.marketActivityApplySpreadInfo = marketActivityApplySpreadInfo;
exports.marketActivityApplyUpdate = marketActivityApplyUpdate;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// ------------------------拼团活动----------------------------------------

/**
 * 分页列表
 * @param
 */
function marketActivityApplyList(pram) {
  var data = {
    page: pram.page,
    limit: pram.limit
  };
  if (pram.goods) {
    data.goods = pram.goods;
  }
  if (pram.nickname) {
    data.nickname = pram.nickname;
  }
  if (pram.activityId !== '' && pram.activityId >= 0) {
    data.activityId = pram.activityId;
  }
  if (pram.marketId !== '' && pram.marketId >= 0) {
    data.marketId = pram.marketId;
  }
  if (pram.applyStatus !== '' && pram.applyStatus >= 0) {
    data.applyStatus = pram.applyStatus;
  }
  if (pram.salesType !== '' && pram.salesType >= 0) {
    data.salesType = pram.salesType;
  }
  return (0, _request.default)({
    url: '/admin/platform/market_activity_apply/list',
    method: 'get',
    params: data
  });
}
/**
 * 修改
 * @param
 */
function marketActivityApplyUpdate(pram) {
  return (0, _request.default)({
    url: "/admin/platform/market_activity_apply/update?id=".concat(pram.id),
    method: 'post',
    data: pram
  });
}

/**
 * 新增
 * @param
 */
function marketActivityApplySave(pram) {
  return (0, _request.default)({
    url: "/admin/platform/market_activity_apply/save",
    method: 'post',
    data: pram
  });
}
/**
 * 删除
 * @param
 */
function marketActivityApplyDelete(id) {
  var data = {
    id: id
  };
  return (0, _request.default)({
    url: "/admin/platform/market_activity_apply/delete?id=".concat(id),
    method: 'get',
    params: data
  });
}
/**
 * 详情
 * @param
 */
function marketActivityApplyInfo(id) {
  var data = {
    id: id
  };
  return (0, _request.default)({
    url: "/admin/platform/market_activity_apply/info",
    method: 'get',
    params: data
  });
}

/**
 * 退还履约保证金
 * @param {number} id 报名ID
 */
function marketActivityApplyRefund(id) {
  return (0, _request.default)({
    url: '/admin/platform/market_activity_apply/refund',
    method: 'get',
    params: {
      id: id
    }
  });
}
/**
 * 审核
 * @param
 */
function marketActivityApplyAudit(data) {
  return (0, _request.default)({
    url: "/admin/platform/market_activity_apply/audit?id=".concat(data.id),
    method: 'post',
    data: data
  });
}

/**
 * 推广审核
 * @param
 */
function marketActivityApplySpreadAudit(data) {
  return (0, _request.default)({
    url: "/admin/platform/market_activity_apply/spread_audit",
    method: 'post',
    data: data
  });
}

/**
 * 推广详情
 * @param
 */
function marketActivityApplySpreadInfo(applyId) {
  return (0, _request.default)({
    url: "/admin/platform/market_activity_apply/spread_info",
    method: 'get',
    params: {
      applyId: applyId
    }
  });
}